module.exports = __webpack_public_path__ + "static/emoji-star-f4d9dc97d52a85809c3f9294ae433c19.png";